import React from "react";
import { b, l1, l2, ramka, krug, zero } from "./icon";

const adjustCalendarPosition = (x, y, width, height, offset = 12) => {
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  let left = x;
  let top = y;

  if (left + width + offset > viewportWidth) {
    left = viewportWidth - width - offset;
  }
  if (left < offset) {
    left = offset;
  }

  if (top + height + offset > viewportHeight) {
    top = y - height - offset;
  }
  if (top < offset) {
    top = offset;
  }

  return { x: left, y: top };
};

export const getClientInfo = (clientData) => {
    if (!Array.isArray(clientData)) {
      return { name: clientData  || "" };
    }

    const name = clientData[0];
    const phoneItem = clientData.find(
      (item) =>
        item &&
        (item.includes("טלפון") ||
          item.includes("Tel") ||
          /\d{3}[-]?\d{7}/.test(item))
    );
    // Если нужно выводить адрес или другие поля, их можно найти методом исключения
    // const other = clientData.filter(item => item !== name && item !== phoneItem);

    return { name, phone: phoneItem || "" };
  };

export function DateBLock({ toDate, fromDate, widthClass = "w-[16%]", onDateChange, statusId, toTime = "10:00" }) {
  const [showCalendar, setShowCalendar] = React.useState(false);
  const [calendarPosition, setCalendarPosition] = React.useState({ x: 0, y: 0 });
  const [anchorPosition, setAnchorPosition] = React.useState({ x: 0, y: 0 });
  const [selectedDate, setSelectedDate] = React.useState(toDate);
  const [selectedTime, setSelectedTime] = React.useState(toTime);
  const calendarRef = React.useRef(null);

  // Sync selectedTime with toTime prop when it changes
  React.useEffect(() => {
    setSelectedTime(toTime);
  }, [toTime]);

  // Sync selectedDate with toDate prop when it changes
  React.useEffect(() => {
    setSelectedDate(toDate);
  }, [toDate]);

  const today = new Date();

  function formatDateDDMMYYYY(date, hasShortYear) {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = hasShortYear
      ? String(date.getFullYear() % 100).padStart(2, "0")
      : String(date.getFullYear());
    return `${day}/${month}/${year}`;
  }

  const hasShortYear =
    typeof fromDate === "string" && /\d{2}\/\d{2}\/\d{2}$/.test(toDate.trim());

  const todayFormatted = formatDateDDMMYYYY(today, hasShortYear);
  const isToday = todayFormatted === selectedDate;

  const handleContextMenu = (e) => {
    const position = { x: e.clientX, y: e.clientY };
    setAnchorPosition(position);
    setCalendarPosition(position);
    setShowCalendar(true);
  };

  React.useLayoutEffect(() => {
    if (showCalendar && calendarRef.current) {
      const rect = calendarRef.current.getBoundingClientRect();
      const adjusted = adjustCalendarPosition(anchorPosition.x, anchorPosition.y, rect.width, rect.height);
      setCalendarPosition(adjusted);
    }
  }, [showCalendar, anchorPosition]);

  const handleDateSelect = (date) => {
    const formattedDate = formatDateDDMMYYYY(date, hasShortYear);
    setSelectedDate(formattedDate);
  };

  const handleTimeChange = (e) => {
    setSelectedTime(e.target.value);
  };

  const handleSave = () => {
    if (onDateChange) {
      onDateChange(selectedDate, selectedTime, statusId);
    }
    setShowCalendar(false);
  };

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    }

    if (showCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCalendar]);

  return (
    <>
      <div className={`flex flex-row ${widthClass} justify-around`}>
        <div className=" h-[100%] content-center font-rubik  font-light text-[clamp(16px,1.5vw,20px)] text-[#7D7D7D] rounded-l-[8px]">
          {fromDate}
        </div>
        <div 
          className={isToday?"h-[100%] content-center font-rubik text-[clamp(16px,1.5vw,20px)] text-[#FF6D00] font-light cursor-pointer":"h-[100%] content-center font-rubik text-[clamp(16px,1.5vw,20px)] text-[#7D7D7D] font-light cursor-pointer"}
          onClick={handleContextMenu}
        >
          {selectedDate}
        </div>
      </div>

      {showCalendar && (
        <div
          ref={calendarRef}
          className="fixed z-50 bg-white rounded-lg shadow-2xl border border-gray-200 p-4"
          style={{
            left: `${calendarPosition.x}px`,
            top: `${calendarPosition.y}px`,
          }}
        >
          <DatePicker onDateSelect={handleDateSelect} currentDate={selectedDate} hasShortYear={hasShortYear} />
          <div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-200">
            <span className="text-sm text-[#7D7D7D] font-rubik">Time:</span>
            <input
              type="time"
              value={selectedTime}
              onChange={handleTimeChange}
              className="font-rubik text-sm text-[#7D7D7D] outline-none border border-gray-200 rounded-md px-2 py-1 cursor-pointer"
            />
          </div>
          <button
            onClick={handleSave}
            className="mt-3 w-full bg-[#739D00] hover:bg-[#5a7a00] text-white font-rubik text-sm font-light rounded-md py-1.5 transition-colors"
          >
            Save
          </button>
        </div>
      )}
    </>
  );
}

function DatePicker({ onDateSelect, currentDate, hasShortYear }) {
  const [currentMonth, setCurrentMonth] = React.useState(new Date());
  
  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split('/');
    const fullYear = year.length === 2 ? `20${year}` : year;
    return new Date(fullYear, month - 1, day);
  };

  const selectedDate = currentDate ? parseDate(currentDate) : new Date();

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();

    return { daysInMonth, startingDayOfWeek };
  };

  const { daysInMonth, startingDayOfWeek } = getDaysInMonth(currentMonth);

  const handlePrevMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1));
  };

  const handleNextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1));
  };

  const handleDayClick = (day) => {
    const newDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
    onDateSelect(newDate);
  };

  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const dayNames = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

  const days = [];
  for (let i = 0; i < startingDayOfWeek; i++) {
    days.push(<div key={`empty-${i}`} className="w-8 h-8"></div>);
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const isSelected = selectedDate.getDate() === day && 
                      selectedDate.getMonth() === currentMonth.getMonth() && 
                      selectedDate.getFullYear() === currentMonth.getFullYear();
    
    days.push(
      <button
        key={day}
        onClick={() => handleDayClick(day)}
        className={`w-8 h-8 flex items-center justify-center rounded-full text-sm hover:bg-[#739D00] hover:text-white transition-colors ${
          isSelected ? 'bg-[#739D00] text-white font-bold' : 'text-gray-700'
        }`}
      >
        {day}
      </button>
    );
  }

  return (
    <div className="w-64">
      <div className="flex items-center justify-between mb-4">
        <button onClick={handlePrevMonth} className="p-1 hover:bg-gray-100 rounded">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <div className="font-semibold text-gray-800">
          {monthNames[currentMonth.getMonth()]} {currentMonth.getFullYear()}
        </div>
        <button onClick={handleNextMonth} className="p-1 hover:bg-gray-100 rounded">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
      
      <div className="grid grid-cols-7 gap-1 mb-2">
        {dayNames.map(day => (
          <div key={day} className="w-8 h-8 flex items-center justify-center text-xs font-semibold text-gray-600">
            {day}
          </div>
        ))}
      </div>
      
      <div className="grid grid-cols-7 gap-1">
        {days}
      </div>
    </div>
  );
}

export function DateBLockKeeper({ toDate, widthClass = "w-[8%]", onDateChange, statusId }) {
  const [showCalendar, setShowCalendar] = React.useState(false);
  const [calendarPosition, setCalendarPosition] = React.useState({ x: 0, y: 0 });
  const [anchorPosition, setAnchorPosition] = React.useState({ x: 0, y: 0 });
  const [selectedDate, setSelectedDate] = React.useState(toDate);
  const calendarRef = React.useRef(null);

  const today = new Date();

  function formatDateDDMMYYYY(date, hasShortYear) {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = hasShortYear
      ? String(date.getFullYear() % 100).padStart(2, "0")
      : String(date.getFullYear());
    return `${day}/${month}/${year}`;
  }

  const hasShortYear =
    typeof toDate === "string" && /\d{2}\/\d{2}\/\d{2}$/.test(toDate.trim());

  const todayFormatted = formatDateDDMMYYYY(today, hasShortYear);
  const isToday = todayFormatted === selectedDate;

  const handleContextMenu = (e) => {
    e.preventDefault();
    const position = { x: e.clientX, y: e.clientY };
    setAnchorPosition(position);
    setCalendarPosition(position);
    setShowCalendar(true);
  };

  React.useLayoutEffect(() => {
    if (showCalendar && calendarRef.current) {
      const rect = calendarRef.current.getBoundingClientRect();
      const adjusted = adjustCalendarPosition(anchorPosition.x, anchorPosition.y, rect.width, rect.height);
      setCalendarPosition(adjusted);
    }
  }, [showCalendar, anchorPosition]);

  const handleDateSelect = (date) => {
    const formattedDate = formatDateDDMMYYYY(date, hasShortYear);
    setSelectedDate(formattedDate);
    if (onDateChange) {
      onDateChange(formattedDate, statusId);
    }
    setShowCalendar(false);
  };

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    }

    if (showCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCalendar]);

  return (
    <>
      <div className={`flex flex-row ${widthClass} justify-around`}>
        <div 
          className={isToday?"h-[100%] content-center font-rubik text-[clamp(16px,1.5vw,20px)] text-[#FF6D00] font-light cursor-pointer":"h-[100%] content-center font-rubik text-[clamp(16px,1.5vw,20px)] text-[#7D7D7D] font-light cursor-pointer"}
          onContextMenu={handleContextMenu}
        >
          {selectedDate}
        </div>
      </div>

      {showCalendar && (
        <div
          ref={calendarRef}
          className="fixed z-50 bg-white rounded-lg shadow-2xl border border-gray-200 p-4"
          style={{
            left: `${calendarPosition.x}px`,
            top: `${calendarPosition.y}px`,
          }}
        >
          <DatePicker onDateSelect={handleDateSelect} currentDate={selectedDate} hasShortYear={hasShortYear} />
        </div>
      )}
    </>
  );
}

const SewingImages = ({ sewing }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  if (!sewing) return null;

  const workers = Array.isArray(sewing) ? sewing : [sewing];
  if (workers.length === 0) return null;

  const hasMore = workers.length > 1;
  const displayWorkers = isExpanded ? workers : [workers[0]];

  return (
    <div
      className="flex items-center cursor-pointer"
      onClick={() => hasMore && setIsExpanded(!isExpanded)}
    >
      {isExpanded ? (
        <div
          className="flex items-center border-solid border-[1.5px] border-[#739D00]"
          style={{ borderRadius: "9999px", padding: "2px 6px" }}
        >
          {displayWorkers.map((worker, idx) => {
            const image = `${
              process.env.PUBLIC_URL
            }/assets/${encodeURIComponent(worker.trim())}.png`;
            return (
              <img
                key={idx}
                src={image}
                style={{
                  height: "40px",
                  width: "40px",
                  objectFit: "contain",
                  marginLeft: idx > 0 ? "-16px" : "0",
                }}
                title={worker}
                alt={worker}
              />
            );
          })}
        </div>
      ) : hasMore ? (
        ramka(workers[0])
      ) : (
        krug(workers[0])
      )}
    </div>
  );
};

export const MembersBlock = (manager, designer, sewing, widthClass = "w-[17%]") => {
  return (
    <div className={`flex ${widthClass} bg-[#F9F9F9] justify-center`}>
      <div className="flex flex-1 items-center px-[24px] ">
        <div className="place-items-start">{renderImage(manager)}</div>
        <div className="place-items-center">{renderImage(designer)}</div>
        <div className="place-items-end">
          <SewingImages sewing={sewing} />
        </div>
      </div>
    </div>
  );
};

export const renderImage = (nameIMG) => {
  if (!nameIMG) return null;

  try {
    const name = nameIMG.trim()==="Manager" ? "Adi" : nameIMG.trim();
    const safeName = encodeURIComponent(name);
    const image = `${process.env.PUBLIC_URL}/assets/${safeName}.png`;

    return (
      <div>
        <img
          src={image}
          style={{
            height: "48px",
            width: "70px",
            margin: "auto",
            objectFit: "contain",
          }}
          title={name}
          alt={name}
        />
      </div>
    );
  } catch {
    return null;
  }
};

export const Button = (image, onClick) => {
  return (
    <div className="w-[10%] content-center">
      <button
        className="flex justify-center items-center w-[100%] h-[100%] bg-[#739D00] rounded-r-[8px] font-medium text-[1vw] text-white hover:bg-[#B9CE80]"
        onClick={onClick}
      >
        {image}
      </button>
    </div>
  );
};

export const imgStudio = (studio) => {
  if (studio.studio) return renderImage("studio");
  if (studio.rip) return renderImage("rip");
  if (studio.print) return renderImage("print");
  if (studio.sewing) return renderImage("sewing");
  if (studio.inWork) return renderImage("inWork");
  if (studio.ready) return renderImage("ready");
  return <div className="w-[24px] h-[24px] rounded-[50%] bg-[#739D00]"></div>;
};

export const iconStatus = [
  "studio",
  "rip",
  "print",
  "sewing",
  "inWork",
  "ready",
];

export const getStudioStatusKey = (studio) => {
  if (studio.studio) return "studio";
  if (studio.rip) return "rip";
  if (studio.print) return "print";
  if (studio.sewing) return "sewing";
  if (studio.inWork) return "inWork";
  if (studio.ready) return "ready";
  return null;
};

export const renderStatusImage = (nameIMG) => {
  try {
    const image = `${process.env.PUBLIC_URL}/assets/${nameIMG}.png` || "";
    if (image != null) {
      return (
        <div className="h-[100%]  content-center hover:scale-110 transition-all">
          <img
            src={image}
            style={{ height: "48px", width: "36px", margin: "auto" }}
            alt={nameIMG}
            title={nameIMG}
          />
        </div>
      );
    }
  } catch {
    return <div className="h-[100%] w-[20%] content-center">{nameIMG}</div>;
  }
};

export const sortDate = (status, object, isAscending = false) => {
  const today = new Date();
  const todayDay = today.getDate();
  const todayMonth = today.getMonth() + 1;
  const todayYear = today.getFullYear() % 100;
  const twoWeeksInMs = 14 * 24 * 60 * 60 * 1000;
  
  return status.sort((a, b) => {
    const [dayA, monthA, yearA] = a[object].split("/");
    const [dayB, monthB, yearB] = b[object].split("/");
    
    const isTodayA = Number(dayA) === todayDay && Number(monthA) === todayMonth && Number(yearA) === todayYear;
    const isTodayB = Number(dayB) === todayDay && Number(monthB) === todayMonth && Number(yearB) === todayYear;
    
    if (isTodayA && !isTodayB) return -1;
    if (!isTodayA && isTodayB) return 1;
    
    const dateA = new Date(2000 + Number(yearA), Number(monthA) - 1, Number(dayA));
    const dateB = new Date(2000 + Number(yearB), Number(monthB) - 1, Number(dayB));
    
    const diffA = today - dateA;
    const diffB = today - dateB;
    
    const isMoreThan2WeeksA = diffA > twoWeeksInMs;
    const isMoreThan2WeeksB = diffB > twoWeeksInMs;
    
    if (isMoreThan2WeeksA && !isMoreThan2WeeksB) return -1;
    if (!isMoreThan2WeeksA && isMoreThan2WeeksB) return 1;
    
    const dateDiff = (yearB - yearA) || (monthB - monthA) || (dayB - dayA);
    if (dateDiff !== 0) return isAscending ? -dateDiff : dateDiff;

    const [hA = 0, mA = 0] = (a.toTime || "10:00").split(":").map(Number);
    const [hB = 0, mB = 0] = (b.toTime || "10:00").split(":").map(Number);
    const timeDiff = (hA * 60 + mA) - (hB * 60 + mB);
    return isAscending ? -timeDiff : timeDiff;
  });
};

export const sortDateDesinger = (status, object, isAscending = false) => {
  return status.sort((a, b) => {
    const [dayA, monthA, yearA] = a[object].split("/");
    const [dayB, monthB, yearB] = b[object].split("/");

    const diff = (yearB - yearA) || (monthB - monthA) || (dayB - dayA);
    return isAscending ? -diff : diff;
  });
};

export const search = (status, textSearch) => {
  if (!textSearch) return status;

  return status.filter(
    (i) =>
      i.toDate?.includes(textSearch) ||
      false ||
      i.fromDate?.includes(textSearch) ||
      false ||
      i.manager?.toLowerCase().includes(textSearch.toLowerCase()) ||
      false ||
      i.designer?.toLowerCase().includes(textSearch.toLowerCase()) ||
      false ||
      i.order?.toLowerCase().includes(textSearch.toLowerCase()) ||
      false ||
      i.client?.[0]?.toLowerCase().includes(textSearch.toLowerCase()) ||
      false
  );
};

export const searchPrint = (status, textSearch) => {
  if (!textSearch) return status;

  return status.map((folder) => ({
    ...folder,
    item:
      folder.item?.filter(
        (i) =>
          i.toDate?.includes(textSearch) ||
          false ||
          i.date?.includes(textSearch) ||
          false ||
          i.manager?.toLowerCase().includes(textSearch.toLowerCase()) ||
          false ||
          i.designer?.toLowerCase().includes(textSearch.toLowerCase()) ||
          false ||
          i.fileName?.toLowerCase().includes(textSearch.toLowerCase()) ||
          false
      ) || [],
  }));
};

export const place = (line) => {
  switch (line) {
    case "LINE 1":
    case "L1":
      return l1;
    case "LINE 2":
    case "L2":
      return l2;
    case "B":
      return b;
    default:
      return zero;
  }
};


